import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";

function Copyright() {
  return (
    <Typography
      variant="body2"
      color={(theme) => theme.palette.text.secondary}
      sx={{ textAlign: "center" }}
    >
      {"Copyright © "}
      <Link
        color="inherit"
        href="https://goo.gl/maps/LXGc5mhasFFDro2NA"
        target="_blank"
      >
        gedeparitrans
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function FooterPart() {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 4,
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="sm">
        <Typography
          sx={{ textAlign: "center" }}
          variant="body1"
          color="text.secondary"
        >
          Gede Pari Trans Wisata Tour Jawa Timur Sewa Mobil plus Driver
        </Typography>
        <Copyright />
      </Container>
    </Box>
  );
}

export default FooterPart;
